import React from 'react';
import IndustryTemplate, { IndustryConfig } from './IndustryTemplate';

const config: IndustryConfig = {
  slug: 'healthcare',
  label: 'Healthcare',
  heroTitle: 'Monetize Your',
  heroDim: 'Clinical Data Assets',
  heroSubtitle:
    'Healthcare providers generate enormous volumes of structured, high-value data — clinical notes, billing records, outcomes, and more. Efficient helps you license de-identified datasets to AI companies, creating a compliant new revenue stream.',
  heroImage: '/healthcare-hero.webp',
  heroImageAlt: 'Healthcare office',
  processSteps: [
    {
      num: '01',
      icon: '/step_door.svg',
      title: 'Data Assessment',
      desc: 'We evaluate your data holdings — EHR records, billing codes, clinical notes — and identify what has value in the AI training market.',
    },
    {
      num: '02',
      icon: '/step_onboard.svg',
      title: 'Compliance Review',
      desc: 'We assess HIPAA obligations, anonymization requirements, and buyer specifications to ensure a fully compliant transaction.',
    },
    {
      num: '03',
      icon: '/step_extract.svg',
      title: 'De-identification & Preparation',
      desc: 'All data is de-identified to Safe Harbor or Expert Determination standards before leaving your systems.',
    },
    {
      num: '04',
      icon: '/step_paid.svg',
      title: 'Revenue Recognition',
      desc: 'Upon delivery, you receive your agreed revenue share — a net-new income stream from data you already hold.',
    },
  ],
  valueHeading: 'What healthcare data can be monetized',
  valueProps: [
    {
      title: 'Clinical Notes & Summaries',
      desc: 'Clinical documentation captures nuanced reasoning and patient context that reflects real-world medical judgment — not just what was diagnosed, but how clinicians think.',
    },
    {
      title: 'Billing & Coding Records',
      desc: 'Billing and coding data reflects the full picture of care delivered — diagnoses, treatments, and the complexity of real patient encounters across your practice.',
    },
    {
      title: 'Outcomes & Treatment Pathways',
      desc: 'Outcomes and care pathways show what actually works across patient populations — grounded in clinical experience that no textbook can replicate.',
    },
  ],
  aiAccelHeading: 'Let AI handle the documentation. Your team handles the care.',
  aiAccelPoints: [
    {
      title: 'Clinical Documentation Automation',
      desc: 'AI scribing and note-generation tools can cut documentation time per visit significantly — giving clinicians more time with patients.',
    },
    {
      title: 'Coding & Billing Assistance',
      desc: 'Automated coding suggestions, claim scrubbing, and denial prediction reduce revenue cycle lag and improve first-pass claim rates.',
    },
    {
      title: 'Care Pathway Optimization',
      desc: 'Surface evidence-based protocol recommendations and flag patients at risk for readmission or gaps in care using your own outcomes data.',
    },
  ],
  ctaHeading: 'Unlock value from your clinical data',
  ctaBody:
    'Join our network of healthcare partners and create compliant new revenue from de-identified data you already hold.',
};

export default function Healthcare() {
  return <IndustryTemplate config={config} />;
}
